import constantsLocal from './constants';
import actionsSync from './actions';
import * as actionsAsync from './actionsAsync';
import reducerLocal from './reducer';

export const consts = constantsLocal;
export const actions = { ...actionsSync, ...actionsAsync };
export default reducerLocal;



// WEBPACK FOOTER //
// ./src/redux/chatConnection/index.js